import React, { lazy } from 'react';
const LandingPage = lazy(() => import("views/LandingPage/LandingPage"));
const AboutUs = lazy(() => import('views/Sections/SectionAboutUs.tsx'))
const Services = lazy(() => import('views/Sections/SectionServices.tsx'))
const ExperienceAI = lazy(() => import('views/Sections/SectionExperienceAI.tsx'))
const AIInvestments = lazy(() => import('views/Sections/SectionAIInvestments.tsx'))
const PortfolioDetail = lazy(() => import('views/Sections/ModelPortfolios/PortfolioDetail.tsx'))
const AIAnalytics = lazy(() => import('views/Sections/SectionAIAnalytics.tsx'))
const CompanyAnalytics = lazy(() => import('views/Sections/CompanyAnalytics/StandalonePage/CompanyAnalyticsPage'))
const MarketInsights = lazy(() => import('views/LandingPage/Services/MarketInsights'))
const Questionnaire = lazy(() => import('views/Questionnaire/Questionnaire.tsx'))
const ShortQuestionnaire = lazy(() => import ('views/Questionnaire/ShortQuestionnaire.tsx'))
const ContactUs = lazy(() => import('views/Sections/SectionContactUs.jsx'))
const BusinessContinuity = lazy(() => import('views/BusinessContinuity/BusinessContinuity.jsx'))
const PrivacyPolicy = lazy(() => import('views/PrivacyPolicy/PrivacyPolicy.jsx'))
const NotFoundPage = lazy(() => import('views/ErrorPage/NotFound.jsx'))
const TermsOfUse = lazy(() => import('views/TermsOfUse/TermsOfUse.jsx'))

const TestPage = React.lazy(() => import("views/Dev/TestPage"));

const publicRoutes = [
  // { 
  //   path: "/test", 
  //   name: "Test", 
  //   component: TestPage, 
  // },
  {
    path: '/',
    name: 'Home',
    component: LandingPage
  },
  {
    path: '/about-us',
    name: 'About Us',
    component: AboutUs
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/ai-investments',
    name: 'AI Investments',
    component: AIInvestments
  },
  {
    path: '/portfolio/:portfolio_id',
    name: 'Portfolio Details',
    component: PortfolioDetail
  },
  {
    path: '/ai-analytics',
    name: 'AI Analytics',
    component: AIAnalytics
  },
  // {
  //   path: '/experience-ai',
  //   name: 'Experience AI',
  //   component: ExperienceAI
  // },
  {
    path: '/company-analytics/:id',
    name: 'Company Analytics',
    component: CompanyAnalytics
  },
  {
    path: '/market-insights',
    name: 'Market Insights',
    component: MarketInsights
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: Questionnaire
  },
  {
    path: '/short-questionnaire',
    name: 'Short Questionnaire',
    component: ShortQuestionnaire
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactUs
  },
  {
    path: '/legal/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicy
  },
  {
    path: '/legal/business-continuity',
    name: 'Business Continuity',
    component: BusinessContinuity
  },
  {
    path: '/legal/terms-of-use',
    name: 'Terms Of Use',
    component: TermsOfUse
  },
  {
    path: '*',
    name: 'Page Not Found',
    component: NotFoundPage
  }
];

const privateRoutes = [

]

export { privateRoutes, publicRoutes };